import storage from "@utils/storage";
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { io, Socket } from "socket.io-client";
import envConfig from "../../environment";

// Define the type for the socket context (can be null or a Socket instance)
type SocketContextType = {
  socket: Socket | null;
  connectSocket: () => void;
};

// Create the context with proper type
const SocketContext = createContext<SocketContextType>({
  socket: null,
  connectSocket: () => { },
});

const isUserLogedIn = !!storage.getToken();
let userId = "";

if (isUserLogedIn) {
  const Id = storage.getUser();
  userId = Id.user.userId;
}

// Custom hook for using the socket
export const useSocket = (): SocketContextType => {
  return useContext(SocketContext);
};

// Props for the provider
interface SocketProviderProps {
  children: ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  const connectSocket = () => {
    const token = storage.getToken();
    if (!token) return;

    const newSocket = io(envConfig.photoUrl, {
      auth: { token },
      transports: ["websocket", "polling"],
    });

    setSocket(newSocket);

    newSocket.on("connect", () => {
      const user = storage.getUser();
      const userId = user?.user?.userId;
      if (userId) {
        newSocket.emit("join chat", userId);
      }
      console.log("Socket connected.");
    });

    newSocket.on("disconnect", () => {
      console.log("Socket disconnected.");
    });

    return () => {
      newSocket.close();
    };
  };

  useEffect(() => {
    if (storage.getToken()) {
      connectSocket();
    }
  }, []);

  return (
    <SocketContext.Provider value={{ socket, connectSocket }}>
      {children}
    </SocketContext.Provider>
  );
};
